import { render, staticRenderFns } from "./v-title.vue?vue&type=template&id=772f539a&scoped=true&"
import script from "./v-title.vue?vue&type=script&lang=js&"
export * from "./v-title.vue?vue&type=script&lang=js&"
import style0 from "./v-title.vue?vue&type=style&index=0&id=772f539a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772f539a",
  null
  
)

export default component.exports